import {ReleaseCalendarFormField, MonthAndYear} from "../types/release-calendar-types";
import {resources} from "../../../../core/models/resource/resources";

export const releaseCalendarResourceType = resources['release-calendar'];

export const years: Array<MonthAndYear> = [
  {
    value: 2022,
    label: '2022'
  },
  {
    value: 2023,
    label: '2023'
  },
  {
    value: 2024,
    label: '2024'
  },
  {
    value: 2025,
    label: '2025'
  },
  {
    value: 2026,
    label: '2026'
  },
  {
    value: 2027,
    label: '2027'
  },
  {
    value: 2028,
    label: '2028'
  }
];

export const months: Array<MonthAndYear> = [
  {
    value: 1,
    label: 'Январь'
  },
  {
    value: 2,
    label: 'Февраль'
  },
  {
    value: 3,
    label: 'Март'
  },
  {
    value: 4,
    label: 'Апрель'
  },
  {
    value: 5,
    label: 'Май'
  },
  {
    value: 6,
    label: 'Июнь'
  },
  {
    value: 7,
    label: 'Июль'
  },
  {
    value: 8,
    label: 'Август'
  },
  {
    value: 9,
    label: 'Сентябрь'
  },
  {
    value: 10,
    label: 'Октябрь'
  },
  {
    value: 11,
    label: 'Ноябрь'
  },
  {
    value: 12,
    label: 'Декабрь'
  }
]

export const days: Array<string> = [ 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс' ]

export const releaseCalendarFormFields: Array<ReleaseCalendarFormField> = [
  {
    fieldName: 'year',
    label: 'Год',
    options: years
  },
  {
    fieldName: 'month',
    label: 'Месяц',
    options: months
  },
]

export const baseBottomOffset: number = 190;
export const baseMobileBottomOffset: number = 280;
